import { render, staticRenderFns } from "./portafolio.vue?vue&type=template&id=4c0dd4d9"
import script from "./portafolio.vue?vue&type=script&lang=js"
export * from "./portafolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports